import { Component, Input, OnInit } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { AppDataService, MerchantUserService, StoreService } from 'app/services';
import moment from 'moment';
import { Utils } from 'app/utils';
import { MerchantUserRolesEnum, TypeMerchantUserEnum } from 'app/models';
import { TableLazyLoadEvent } from 'primeng/table';

enum MenuTabEnum {
    EmployeeDetail = 1,
    Store = 2,
    Transactions = 3,
    AuditLog = 4
}

@Component({
    selector: 'partner-employee-details',
    templateUrl: './partner-employee-details.component.html',
    styleUrls: ['./partner-employee-details.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class PartnerEmployeeDetailsComponent implements OnInit {
    constructor(
        private messageService: MessageService,
        private storeService: StoreService,
        private merchantUserService: MerchantUserService,
        private appData: AppDataService) {
        this.handleDeleteEmployeeHide = this.handleDeleteEmployeeHide.bind(this);
        this.handleSuspendEmployeeHide = this.handleSuspendEmployeeHide.bind(this);
        this.handleResetPasswordHide = this.handleResetPasswordHide.bind(this);
    }
    ngOnInit(): void {

    }

    @Input()
    public visible!: boolean;
    @Input()
    public onHide: () => void = () => { };
    @Input()
    public employee: any;

    //Transactions. Table settings
    public transactionsCols: any[] = [
        { field: 'StatusStr', header: 'TRXN Type', width: '20%' },
        { field: 'OrderId', header: 'Order ID', width: '20%' },
        { field: 'CreatedAt', header: 'Date & Time', width: '20%' },
        { field: 'StoreName', header: 'Location', width: '20%' }
    ];

    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    private searchTimer: number = 0;

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getMerchantUserTransactions(skip);
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getMerchantUserTransactions(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public filter: {
        startDate: Date | undefined;
        endDate: Date | undefined;
    } = { startDate: undefined, endDate: undefined };

    public handleFilterClear() {
        this.filter.startDate = undefined;
        this.filter.endDate = undefined;
        this.getMerchantUserTransactions(0);
    }

    public transactions: Array<any> = [];

    public getMerchantUserTransactions(skip: number) {
        const dto = {
            MerchantUserId: this.employee.UserId,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            StartDate: this.filter.startDate ? moment(this.filter.startDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            EndDate: this.filter.startDate ? moment(this.filter.endDate).format('YYYY-MM-DDTHH:mm:ss') : null
        };

        this.merchantUserService.getMerchantUserHistory(dto, this.messageService)
            .then(data => {

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.transactions = data.Items.map((x: any) => {
                    x.CreatedAt = moment(Utils.utcToLocalDate(x.CreatedAt)).format('YYYY-MM-DD | H:mm');
                    return x;
                });;

            });

    }

    public menuTab = MenuTabEnum;
    public activeTab: MenuTabEnum = MenuTabEnum.EmployeeDetail;
    public menuItems: MenuItem[] = [
        {
            label: 'Employee Details',
            command: (e: any) => this.handleTabChange(MenuTabEnum.EmployeeDetail)
        },
        {
            label: 'Store Assignment',
            command: (e: any) => this.handleTabChange(MenuTabEnum.Store)
        },
        {
            label: 'Transactions',
            command: (e: any) => this.handleTabChange(MenuTabEnum.Transactions)
        },
        {
            label: 'Audit Log',
            command: (e: any) => this.handleTabChange(MenuTabEnum.AuditLog)
        }
    ];

    public stores: any[] = [];

    public showDeleteEmployee: boolean = false;
    public showSuspendEmployee: boolean = false;
    public showResetPassword: boolean = false;

    public handleDeleteEmployeeHide() {
        this.showDeleteEmployee = false;
    }

    public handleResetPasswordHide() {
        this.showResetPassword = false;
    }

    public handleSuspendEmployeeHide() {
        this.showSuspendEmployee = false;
    }

    public showDeleteEmployeeDialog() {
        this.showDeleteEmployee = true;
    }

    public showResetPasswordDialog() {
        this.showResetPassword = true;
    }

    public showSuspendEmployeeDialog() {
        this.showSuspendEmployee = true;
    }

    public menuEditLocationItems: MenuItem[] = [
        {
            items: [
                {
                    label: 'Remove From Store',
                    command: () => {
                        this.removeFromStore();
                    }
                }
            ]
        }
    ];

    //Google maps autocomplete
    public addresses: any[] = [];

    public search(event: any) {
        const query = event.query;
        const service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({ input: query }, (predictions, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                this.addresses = predictions ? predictions.map((prediction) => prediction.description) : [];
            } else {
                this.addresses = [];
            }
        });
    }

    public handleTabChange(menuTab: MenuTabEnum) {
        this.activeTab = menuTab;
        if (menuTab === this.menuTab.Transactions) {
            //this.getMerchantUserTransactions(0);
        }
        if (menuTab === this.menuTab.Store) {
            this.getMerchantLocations();
        }
    }

    public merchantUserRoles: any[] = [
        {
            id: MerchantUserRolesEnum.StoreManager,
            name: 'Store Manager'
        },
        {
            id: MerchantUserRolesEnum.Cashier,
            name: 'Cashier'
        },
        {
            id: MerchantUserRolesEnum.Dispatcher,
            name: 'Dispatcher'
        },
        {
            id: MerchantUserRolesEnum.Root,
            name: 'Root'
        }
    ];

    public typesMerchantEmployee = TypeMerchantUserEnum;
    public loading: boolean = false;

    public handleClose() {
        this.visible = false;
        this.onHide();
        this.activeTab = this.menuTab.EmployeeDetail;
    }

    //Upload image
    public handleInputClick(id: string): void {
        document.getElementById(id)?.click();
    }
    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }
        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.employee.ImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    public getMerchantLocations() {
        const dto = {
            MerchantId: this.appData.authData.MerchantId
        };

        this.storeService.getStoresByMerchant(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    //this.storesLoading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.stores = data.Items;
                this.employee.Store = this.employee.StoreId ? this.stores[this.stores.findIndex(store => store.Id === this.employee.StoreId)] : null;
                //  this.storesLoading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public addStoreToUser(event: any) {
        this.employee.Store = this.employee.StoreId ? this.stores[this.stores.findIndex(store => store.Id === this.employee.StoreId)] : null;
    }

    public removeFromStore() {
        this.employee.StoreId = undefined;
        this.employee.Store = undefined;
    }

    public updateMerchantUser() {
        if (!this.checkFields()) {
            return;
        }
        const dto = this.getEmployeeDto();

        this.loading = true;
        this.merchantUserService.updateMerchantUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Employee has been update' });
                this.handleClose();
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public checkFields(): boolean {
        if (!this.employee.Email) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Email not specified' });
            return false;
        }
        if (!this.checkEmail(this.employee.Email)) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Email is incorrect' });
            return false;
        }
        if (!this.employee.Phone) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Phone not specified' });
            return false;
        }
        if (!this.checkPhone(this.employee.Phone)) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid phone number' });
            return false;
        }
        if (!this.employee.FirstName) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'FirstName not specified' });
            return false;
        }
        if (!this.employee.LastName) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'LastName not specified' });
            return false;
        }
        if (!this.employee.Birthday) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Birthday not specified' });
            return false;
        }
        if (new Date(this.employee.Birthday) > new Date()) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Birthday cant be more today' });
            return false;
        }
        if (!this.employee.RoleId) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Role not specified' });
            return false;
        }

        return true;
    }

    private getEmployeeDto() {
        return {
            UserId: this.employee.UserId,
            Email: this.employee.Email,
            Phone: this.employee.Phone,
            FirstName: this.employee.FirstName,
            LastName: this.employee.LastName,
            Address: this.employee.Address ?? '',
            Birthday: moment(this.employee.Birthday).format('YYYY-MM-DD'),
            RoleId: this.employee.RoleId,
            ExternalId: this.employee.ExternalId ?? '',
            StoreId: this.employee.Store.Id,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            MerchantId: this.appData.authData.MerchantId,
            ImageUrl: this.employee.ImageUrl
        };
    }

    private checkPhone(phone: string) {
        const phoneRegex = /^\+?\d{10,14}$/;
        return phoneRegex.test(phone);
    }

    private checkEmail(email: string) {
        const mailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        return mailRegex.test(email);
    }

}
